import {
  NavigationTrigger,
  ReaderNavigationContext,
} from "../../screens/reader/types";

export function normalizeStreamSource(stream?: string): string | undefined {
  if (!stream || stream === "home") {
    return stream;
  }

  return stream.startsWith("channel/") ? stream : `channel/${stream}`;
}

function getSurfaceSource(navigationContext?: ReaderNavigationContext): string {
  const area = navigationContext?.area;
  const trigger = navigationContext?.trigger;
  const stream = normalizeStreamSource(navigationContext?.stream);
  if (area === "search") {
    return "search";
  }

  const hasSearchQuery = Boolean(
    trigger === NavigationTrigger.searchResultCard ||
    navigationContext?.searchQueryId ||
    navigationContext?.q,
  );

  if (hasSearchQuery) {
    return "search";
  }

  if (area === "notifications" || area === "push-notification") {
    return "notifications";
  }

  if (area === "comic-details") {
    return "comic_details";
  }

  if (area === "release-details") {
    return "release_details";
  }

  if (area === "bundle-details") {
    return "bundle_details";
  }

  if (area === "chat") {
    return "chat";
  }

  if (area === "trends") {
    return "trends";
  }

  if (area === "publisher" || area === "artist") {
    return "publisher_details";
  }

  if (area === "library") {
    return "library";
  }

  if (area === "browse") {
    return "browse";
  }

  if (area === "books") {
    return "books";
  }

  if (area === "creators") {
    return "creators";
  }

  if (area === "consumption" || area === "interstitial") {
    return "reader";
  }

  if (area === "my-downloads" || area === "downloads" || area === "offline") {
    return "downloads";
  }

  if (area === "view-all") {
    return "view_all";
  }

  if (area === "home") {
    return stream && stream !== "home" ? stream : "home";
  }

  if (area === "gc-originals") {
    return stream || "others";
  }

  if (area === "external") {
    return "deep_link";
  }

  if (
    trigger === NavigationTrigger.heroCardClicked ||
    trigger === NavigationTrigger.featureCardClicked
  ) {
    return stream || "home";
  }

  if (trigger === NavigationTrigger.trendsComicCard) {
    return "trends";
  }

  if (trigger === NavigationTrigger.specialLandingPageCard) {
    return "others";
  }

  if (trigger === NavigationTrigger.readerRedirect) {
    return "deep_link";
  }

  if (!trigger && !area) {
    return "deep_link";
  }

  return "others";
}

export function mapDetailSourceFromNavigation(
  navigationContext?: ReaderNavigationContext,
): string {
  return getSurfaceSource(navigationContext);
}

export function mapReadingSourceFromNavigation(
  navigationContext?: ReaderNavigationContext,
): string {
  const trigger = navigationContext?.trigger;

  if (
    trigger === NavigationTrigger.nextReleaseButton ||
    trigger === NavigationTrigger.startNextReleaseButton ||
    trigger === NavigationTrigger.previousReleaseButton ||
    trigger === NavigationTrigger.paywallClose
  ) {
    return "reader";
  }

  if (
    trigger === NavigationTrigger.continueReadingButton ||
    trigger === NavigationTrigger.startReadingButton ||
    trigger === NavigationTrigger.releasesListCard
  ) {
    return "comic_details";
  }

  if (
    trigger === NavigationTrigger.previewReleaseButtonReleaseContextual ||
    trigger === NavigationTrigger.startReadingButtonReleaseContextual ||
    trigger === NavigationTrigger.continueReadingButtonReleaseContextual ||
    trigger === NavigationTrigger.previewReleaseButtonReleaseDetails ||
    trigger === NavigationTrigger.startReadingButtonReleaseDetails ||
    trigger === NavigationTrigger.continueReadingButtonReleaseDetails ||
    trigger === NavigationTrigger.pageThumbnailCard
  ) {
    return "release_details";
  }

  if (trigger === NavigationTrigger.relatedListCard) {
    return navigationContext?.area === "consumption" ||
      navigationContext?.area === "interstitial"
      ? "reader"
      : "comic_details";
  }

  return getSurfaceSource(navigationContext);
}
